import { Button } from "@components/button";
import { Input } from "@components/input";
import { useAuth } from "@features/auth";
import { AuthForm } from "@features/auth/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { loginSchema } from "../schemes";
import styles from "./login.module.scss";

type Props = {
  withCode?: boolean;
};

export const LoginForm = ({ withCode }: Props) => {
  const { auth } = useAuth();

  const navigate = useNavigate();

  const { control, handleSubmit, setError, formState } = useForm<AuthForm>({
    resolver: yupResolver(loginSchema),
    defaultValues: { email: "", password: "", code: "" },
  });

  const onSubmit = async (data: AuthForm) => {
    try {
      await auth(data);
    } catch (error) {
      switch (error) {
        case "INVALID_CODE":
        case "CODE_NOT_PROVIDED":
          setError("code", {
            type: "server",
            message: "Неверный код. Попробуйте снова",
          });
          if (!withCode) {
            navigate("/");
          }
          break;

        case "INVALID_LOGIN_CREDENTIALS":
          setError("email", {
            type: "server",
            message: "Неверный e-mail или пароль",
          });
          setError("password", {
            type: "server",
            message: "Неверный e-mail или пароль",
          });
          break;

        case "UNVERIFIED_EMAIL : Need to verify email first before enrolling second factors.":
          setError("email", {
            type: "server",
            message: "Подтвердите почту",
          });
          break;
      }
    }
  };

  return (
    <form className={styles.form}>
      <Input
        label="E-mail"
        name="email"
        control={control}
        placeholder="Введите e-mail"
        className={styles.input}
      />
      <Input
        label="Пароль"
        type="password"
        name="password"
        control={control}
        placeholder="Введите пароль"
        className={styles.input}
      />
      {withCode && (
        <Input
          label="Одноразовый код"
          name="code"
          control={control}
          placeholder="Введите одноразовый код"
          className={styles.input}
        />
      )}
      <Button
        className={styles.button}
        onClick={handleSubmit(onSubmit)}
        disabled={formState.isSubmitting}
      >
        Войти
      </Button>
    </form>
  );
};
